const PaymentDate = require('./PaymentDate');
const Value = require('./Value');
const DueDate = require('./DueDate');
const Barcode = require('./Barcode');
const { errors, billetType } = require('@transfeeradev/api-enums');
const ClearMaskService = require('../services/ClearMaskService');
const GetTypeService = require('../services/GetTypeService');

class Validation {
  constructor(
    data = {
      billet: {},
      disallowOverdue: false,
      allowCustomValue: false
    }
  ) {
    this._billet = { ...data.billet };
    this._disallowOverdue = data.disallowOverdue;
    this._allowCustomValue = data.allowCustomValue;
    this._type = GetTypeService.get(this._billet.barcode);
  }

  validateBarcode() {
    if (!this._billet && !this._billet.barcode) {
      throw new Error(errors.ptBr.bil.BARCODE_IS_REQUIRED);
    }

    this._billet.barcode = ClearMaskService.clear(this._billet.barcode);

    const validationErrors = [];

    const value = new Value(this._billet, {
      disallowOverdue: this._disallowOverdue,
      allowCustomValue: this._allowCustomValue
    }).validate();

    if (!value.isValid) {
      validationErrors.push(value);
    }

    if (this._type === billetType.SIMPLE && this._disallowOverdue) {
      const dueDate = new DueDate(this._billet).validate();

      if (!dueDate.isValid) {
        validationErrors.push(dueDate);
      }
    }

    const barcode = new Barcode(this._billet).validate();

    if (!barcode.isValid) {
      validationErrors.push(barcode);
    }

    return validationErrors;
  }

  validate() {
    let validatioErrors = [];

    const barcodeValidation = this.validateBarcode();

    if (barcodeValidation.length) {
      validatioErrors = validatioErrors.concat(barcodeValidation);
    }

    const paymentDate = new PaymentDate(this._billet, {
      disallowOverdue: this._disallowOverdue
    }).validate();

    if (!paymentDate.isValid) {
      validatioErrors.push(paymentDate);
    }

    return validatioErrors;
  }
}

module.exports = Validation;
